import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  Wrapper,
  Header,
  VehicleSectionWrapper,
  MiscFeeSectionWrapper,
  Pre1981DataSectionWrapper,
  FieldsWrapper,
  ButtonPrimary,
  MessageSection
} from "./Section.styles";
import WorkItemFormField from "./Field";
import WorkItemFormVehicleSection from "./Vehicle/Section";
import LoaderSection from "../../UI/Loader/LoaderSection/LoaderSection";
import UISearchDropdown from "components/UI/SearchDropdown";
import IconChange from "components/Icon/Change";
import IconCancel from "components/Icon/Cancel";
import MiscFee from "components/WorkItem/MiscellaneousFee/MiscFee";
import Pre1981Data from "components/WorkItem/pre1981Data/Pre1981Data"

const WorkItemFormSection = ({
  hasNext,
  fields,
  header,
  vehicle,
  onFieldChange,
  onClickNext,
  features,
  onFieldsNext,
  stateName,
  sectionMessage,
  isCloned,
  listItems,
  workitemId,
  onChangeState,
  onAddMiscFee,
  onSetMiscFeeValue,
  onSetPre1981DataValue,
  miscFees,
  pre1981Data,
  claimTypeItems
}) => {
  const [stateChange, setStateChange] = useState(false);

  const onChangeIconClick = () => {
    setStateChange(stateChange ? false : true);
  }
  const onSelectedState = (e) =>{
    onChangeState(e, workitemId);    
  }

  const onClickAddMiscFee = () => {
    const id = Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
    const newFeeMisc = [
      {
          state: "",
          sequence: `feeName${id}`,
          name: "MiscFee",
          key: `MiscFee${id}`,
          label: "Fee Name",
          value: "",
          validValues: {
              value: "",
              text: ""
          },
          fieldType: "Text",
          helpText: "Fee Name",
          mask: null,
          maxLength: null,
          required: "True",
          disabled: null,
          groupField: "MiscFee"
      },
      {
        state: "",
        sequence: `feeAmount${id}`,
        name: "MiscFee",
        key: `MiscFee${id}`,
        label: "Fee Amount",
        value: "",
        validValues: {
            value: "",
            text: ""
        },
        fieldType: "Currency",
        helpText: "Fee Amount",
        mask: null,
        maxLength: null,
        required: "True",
        disabled: null,
        groupField: "MiscFee"
      },
      {
        state: "",
        sequence: `claimType${id}`,
        name: "MiscFee",
        key: `MiscFee${id}`,
        label: "Claim Type",
        value: "",
        items: claimTypeItems,
        fieldType: "DropDown",
        helpText: "Claim Type",
        mask: null,
        maxLength: null,
        required: "True",
        disabled: null,
        groupField: "MiscFee"
      }
    ];
    miscFees.push(newFeeMisc);
    onAddMiscFee(miscFees);
  }

  const changeDisplayIcon = (hasNext && isCloned) && stateChange ? <IconCancel /> : <IconChange /> ;
  const changeStateIcon = hasNext && isCloned ? ( <div onClick={onChangeIconClick}>{changeDisplayIcon}</div> ) : null;
  const stateDropdown = stateChange && isCloned ? ( 
    <span style={{paddingLeft: '3px', textTransform:"capitalize"}}>
      <UISearchDropdown
          onSelection={onSelectedState}
          placeholder="Select"
          items={listItems.filter(state => state.text !== stateName)}
          containerProps={{ className: "states-dropdown" }}
          data-state-dropdown
          id="select_state"
        />
      </span>
   ) : null;

  const vehicleSection = vehicle  ? (
    <WorkItemFormVehicleSection vehicle={vehicle} />
  ) : null;

    const miscFeeSection = ((vehicle || (pre1981Data != undefined ? pre1981Data.length > 0 : false)) && stateName != "California") ? (
    <MiscFeeSectionWrapper><MiscFee key="miscFees" miscFees={miscFees} onAddMiscFee={onClickAddMiscFee} onSetMiscFeeValue={onSetMiscFeeValue}/></MiscFeeSectionWrapper>
    ) : null;

    const pre1981DataSection = (pre1981Data != undefined ? pre1981Data.length > 0 : false) ? (
        <Pre1981DataSectionWrapper><Pre1981Data key="pre1981Data" pre1981Data={pre1981Data} onSetPre1981DataValue={onSetPre1981DataValue} /></Pre1981DataSectionWrapper>
    ) : null;

  const nextButton = hasNext ? (
    <ButtonPrimary
      id="nextSection"
      name="Next"
      onClick={() => onClickNext(fields)}
      disabled={false}
      data-next-btn
      isloading={onFieldsNext.toString()}
    >
      Next
    </ButtonPrimary>
  ) : null;

  const formFields = fields.map(x => (
    <WorkItemFormField
      id={"span" + x.key}
      key={x.key}
      item={x}
      stateName={stateName}
      onChange={onFieldChange}
      features={features}
      data-field-key={x.key}
      style={{ display: x.key === "cMake" || x.key === "cYear" ? "none" : "" }}
      autocomplete="nope"
    />
  ));
  const sectionLoader = onFieldsNext ? <LoaderSection loader={false} /> : null;
  const sectionMessageDiv = sectionMessage === "" ? null : <MessageSection>{sectionMessage}</MessageSection>;

  return (
    <Wrapper data-wi-form-section>
      {sectionLoader}
      <Header id={`${header}_id`}>
        State: {stateChange && isCloned ? null : header}
        {stateDropdown}
        {changeStateIcon}
      </Header>

      <VehicleSectionWrapper>
        {vehicleSection}
      </VehicleSectionWrapper>

      <FieldsWrapper>
        {formFields}
        {nextButton}
      </FieldsWrapper>
        {pre1981DataSection}
        {miscFeeSection}
      {sectionMessageDiv}
    </Wrapper>
  );
};

WorkItemFormSection.propTypes = {
  hasNext: PropTypes.bool,
  onFieldsNext: PropTypes.bool,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
      ])
    })
  ),
  header: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element
  ]),
  onClickNext: PropTypes.func,
  onFieldChange: PropTypes.func,
  vehicle: PropTypes.any
};

WorkItemFormSection.defaultProps = {
  hasNext: false,
  sectionMessage: "",
  fields: [],
  header: "",
  onClickNext: () => {},
  onFieldChange: () => {}
};

export default WorkItemFormSection;
